import { Injectable } from '@angular/core';

@Injectable()
export class SiteFormValidationService {
  constructor(
  ) {}

  public validateForm(answers: any, formData: any[], pendingUploads: any = {}): any[] {
    let validationErrors = [];

    let length = JSON.stringify(answers).length;
    if (length >= 65535) {
      validationErrors.push({ message: 'This form is too large to save. Try shortening some of the text responses.' });
    }

    for (let i = 0; i < formData.length; i++) {
      const field = formData[i];

      if (field.required && field.type === 'table') {
        // at least one row has values. (more fine grain validation in row handled in table-modal)
        if (!answers[i] || answers[i].length < 1) {
          validationErrors.push({ message: `"${field.label}" is required`, key: i, field: field });
        } else {
          let rows = answers[i];

          let anyRowHasValue = rows.some(row => {
            return Object.keys(row).some(key => row[key] !== null && row[key] !== undefined);
          });


          if (!anyRowHasValue) {
            validationErrors.push({ message: `"${field.label}" is required`, key: i, field: field });
          }
        }
      } else if (field.required && field.type === 'checkboxList') {
        if (!answers[i] || !answers[i].length) {
          validationErrors.push({ message: `"${field.label}" is required`, key: i, field: field });
        }
      } else if (field.required && (field.type === 'imageUpload' || field.type === 'documentUpload')) {
        const hasPendingUpload = Array.isArray(pendingUploads[i]) && pendingUploads[i].length > 0;

        if (!hasPendingUpload) {
          validationErrors.push({ message: `"${field.label}" is required`, key: i, field: field });
        }
      } else if (field.required && !answers[i]) {
        // does field have a value in the answers object
        validationErrors.push({ message: `"${field.label}" is required`, key: i, field: field });
      }
    }
    return validationErrors;
  }

}
